<template>
  <div>
    <h1 class="case-detail-title">{{$t('editCase.slideDetails')}}</h1>
    <div style="height: 514px;">
      <Form ref="slideInfo" :model="slideInfo" :label-width="100" :rules="ruleSlide">
        <Row>
          <FormItem :label="$t('editCase.slideNumber')" prop="slide_code" class="case-detail-form-item">
            <Input v-model="slideInfo.slide_code" maxlength="20"></Input>
          </FormItem>
        </Row>
        <Row>
          <FormItem :label="$t('addNewCase.caseInfo.analysisType')" class="case-detail-form-item">
            <Select v-model="slideInfo.pathology_type" disabled>
              <Option v-for="item in fxffList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Row>
      </Form>
      <div>
        <ul>
          <li v-for="(material, index) in materialList" :key="index" class="case-detail-material-li">
            <img :src="material.url" class="case-detail-material-img"/>
          </li>
        </ul>
        <div class="case-detail-clear"></div>
      </div>
      <div style="margin: 20px auto;text-align: center">
        <Button type="primary" size="large" @click.native="sliFormValidate('slideInfo')">{{$t('editCase.saveTheSlide')}}</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props: ['fxffList', 'rslxList', 'slideInfo', 'materialList', 'slideId'],
  data () {
    return {
      ruleSlide: {
        slide_code: [
          { required: true, message: this.$t('editCase.slideNumberTip'), trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.$vue = this
  },
  methods: {
    sliFormValidate (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveSlide()
        } else {
          this.warning()
        }
      })
    },
    async saveSlide () {
      let params = new URLSearchParams()
      params.append('slideInfo', JSON.stringify(this.slideInfo))
      params.append('slideId', this.slideId)
      let suc = await this.$http.post(this.$vue.getData('GET_EDIT_SAMPLE_SLIDE_URL'), params)
      if (suc.data.result === '1') {
        this.addSlide = false
        this.$emit('reLoadSampleSlideList')
        this.success()
      } else {
        this.warning()
      }
    },
    // 保存成功消息提醒
    success () {
      this.$Notice.success({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.saveSlideSuccessfully')
      })
    },
    // 保存失败消息提醒
    warning () {
      this.$Notice.error({
        title: this.$t('caseList.messageNotification'),
        desc: this.$t('editCase.saveSlideFailed')
      })
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .case-detail-title
    font-weight bolder
    font-size 20px
    color #2d8cf0
    margin-bottom 24px
  .case-detail-form-item
    width 100%
    display inline-block
    padding-right 2%
  .case-detail-material-li
    display inline-block
    margin 12px 12px
    float left
  .case-detail-material-img
    width 80px
    height 80px
    border: 2px solid #42c2f3
  .case-detail-clear
    clear both
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/caseDetail/Slide.vue